import { createActionGroup, emptyProps } from '@ngrx/store';

/**
 * UI Actions
 * 
 * Defines all actions for UI state management.
 * These actions handle cross-cutting UI concerns.
 */
export const UiActions = createActionGroup({
  source: 'UI',
  events: {
    'Toggle Sidenav': emptyProps(),
    'Open Sidenav': emptyProps(),
    'Close Sidenav': emptyProps(),
    'Show Global Loading': emptyProps(),
    'Hide Global Loading': emptyProps(),
  }
});
